import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { MyDispatch, MySelector } from "../../redux/store"
import { Box, Modal } from "@mui/material"
import { setDeleteArray } from "../../redux/utilSlice"
import {
  btnsParent,
  desc,
  leftBtn,
  returnStyle,
  rightBtn,
  title,
} from "../../utils/popupModalStyle"
import { HandleAsyncFns } from "../../hooks/handleAsyncFns"

const DeleteModal = () => {
  const dispatch = useDispatch<MyDispatch>()

  const { deleteArray, type } = MySelector((state) => state.util)
  const { theme } = MySelector((state) => state.theme)

  const { deleteFile } = HandleAsyncFns()

  const [showModal, setShowModal] = useState(false)

  // to toggle the modal
  useEffect(() => {
    if (!deleteArray) setShowModal(false)
    else setShowModal(true)
  }, [deleteArray])

  return (
    <Modal
      open={showModal}
      onClose={() => {
        setShowModal(false)
        dispatch(setDeleteArray(null))
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={returnStyle(theme)}>
        <div className="p-5 md:px-[26.11px] md:py-[33.25px]">
          <p className={title}>{type === "gallery" ? "Delete" : "Remove"}</p>
          <p className={desc}>
            {type === "gallery"
              ? "Are you sure you want to delete this file?"
              : "Are you sure you want to remove this file from physical album?"}
          </p>
          <div className={btnsParent}>
            <button
              onClick={() => {
                setShowModal(false)
                dispatch(setDeleteArray(null))
              }}
              className={leftBtn}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                deleteFile?.(deleteArray || [])
                dispatch(setDeleteArray(null))
              }}
              className={rightBtn}
            >
              {type === "gallery" ? "Delete" : "Remove"}
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  )
}

export default DeleteModal
